import "./App.css";
import config, { config2 } from "./config";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import Dashboard from "./pages/Dashboard/Dashboard";
import ExpenseCategoryList from "./pages/ExpenseCategory/List";
import ExpenseCategoryAdd from "./pages/ExpenseCategory/Add";
import ExpenseCategoryEdit from "./pages/ExpenseCategory/Edit";
import ExpenseList from "./pages/Expense/List";
import ExpenseAdd from "./pages/Expense/Add";
import ExpenseEdit from "./pages/Expense/Edit";
import ExpenseView from "./pages/Expense/View";
import PurchaseList from "./pages/Purchase/List";
import PurchaseAdd from "./pages/Purchase/Add";
import PurchaseView from "./pages/Purchase/View";
import PurchaseEdit from "./pages/Purchase/Edit";
import SaleList from "./pages/Sale/List";
import SaleAdd from "./pages/Sale/Add";
import SaleView from "./pages/Sale/View";
import SaleEdit from "./pages/Sale/Edit";
import TempSaleList from "./pages/TempSale/List";
import Login from "./pages/Auth/Login";
import Logout from "./pages/Auth/Logout";
import ProtectedRoute from "./components/ProtectedRoute";
import { createContext, useEffect, useState, useRef, useCallback } from "react";
import SettingList from "./pages/Setting/List";
import GodownList from "./pages/Master/Godown";
import BranList from "./pages/Master/Branch";
import CompanyList from "./pages/Master/Company";
import BuyerList from "./pages/Master/Buyer";
import ItemCatList from "./pages/Master/ItemCategory";
import UserList from "./pages/Master/User";
import ItemList from "./pages/Master/Item";
import CustomerList from "./pages/Master/Customer";
import UOMList from "./pages/Master/UOM";
import StockAdjustment from "./pages/Stock2/List";
import StockAdjustmentAdd from "./pages/Stock2/Add";
import StockAdjustmentEdit from "./pages/Stock2/Edit";
import StockAdjustmentView from "./pages/Stock2/View";
import $ from "jquery";
import { apiListBranch, apiListBuyer, apiListItem } from "./api/master";
import StockSummary from "./pages/Report/Stock Summary/List";
import StockMovement from "./pages/Report/Stock Movement/List";
import SaleItemMovement from "./pages/Report/Sale Item Movement/List";
import SaleMovement from "./pages/Report/Sale Movement/List";
import PurchaseMovement from "./pages/Report/Purchase Movement/List";
import PaymentMovement from "./pages/Report/Payment Movement/List";
import PaymentSummary from "./pages/Report/Payment Summary/List";
import ChallanReturnAdd from "./pages/Sale/Sale Return/Add";
import ChallanReturnEdit from "./pages/Sale/Sale Return/Edit";
import ChallanRtnList from "./pages/Sale/Sale Return/List";
import ChallanReturnView from "./pages/Sale/Sale Return/View";
import PurchaseReturnList from "./pages/PurchaseReturn/List";
import PurchaseReturnAdd from "./pages/PurchaseReturn/Add";
import PurchaseReturnView from "./pages/PurchaseReturn/View";
import PurchaseReturnEdit from "./pages/PurchaseReturn/Edit";
import * as qz from "qz-tray";
import { hextorstr, KEYUTIL, KJUR, stob64 } from "jsrsasign";
import LoginPinBased from "./pages/Authentication/Login";
import NonMovingItems from "./pages/Report/Non Moving Items/List";
import moment from "moment";
import Swal from "sweetalert2";
import SaleReturnMovement from "./pages/Report/Sale Return Movement/List";
import PurchaseReturnMovement from "./pages/Report/Purchase Return Movement/List";
import ItemizedPurchase from "./pages/Report/Itemize Purchase/List";
import SyncLogList from "./pages/SyncLog/List";
import { initThemeObserver, fetchAndApplyUserTheme } from "./themeManager";

export const ReportContext = createContext(null);
export const ConfigContext = createContext(null);

function App() {
  const [compConfig, setCompConfig] = useState([]);
  const [itemList, setItemList] = useState([]);

  const isRestrictedUser = () => {
    const localUser = JSON.parse(
      localStorage.getItem("inventory") || "null",
    )?.userData;
    const userId = user?.user_id || localUser?.user_id;
    return [93, 178, "93", "178"].includes(userId);
  };
  const [godown, setGodown] = useState([]);
  const [voucherList, setVoucherList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [loginBranch, setLoginBranch] = useState();
  const [userBranchId, setUserBranchId] = useState("");
  const [buyerList, setBuyerList] = useState([]);
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState({});
  const [comp, setComp] = useState({});

  const [serverDate, setServerDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [alertMeta, setAlertMeta] = useState(null);
  const [daysLeft, setDaysLeft] = useState(null);

  console.log("loginBranch", loginBranch);

  const isAlertShownRef = useRef(false);
  const expiryIntervalRef = useRef(null);

  useEffect(() => {
    initThemeObserver();
    const inv = localStorage.getItem("inventory");
    if (inv) {
      const data = JSON.parse(inv).userData;
      setUser(data);
      setComp(data?.comp_data);
      setLoggedIn(true);
      if (data?.user_id) {
        fetchAndApplyUserTheme(data.user_id);
      }
    } else {
      setLoggedIn(false);
    }
  }, []);

  useEffect(() => {
    async function fetchAlertDataOnce() {
      if (!localStorage.getItem("inventory")) return;

      try {
        const inv = JSON.parse(localStorage.getItem("inventory"));
        const comp_id = inv?.userData?.comp_id;

        if (!comp_id) return;

        const response = await $.post(
          `${config.apiUrl}/company/getExpiryNotification`,
        );
        console.log("✅ Alert API Response:", response);

        const raw = response?.data?.data || response?.data || null;

        if (!raw) return;
        try {
          const localData = JSON.parse(localStorage.getItem("inventory"));

          if (localData && localData.userData.comp_data[0]) {
            localData.userData.comp_data[0].expiry_date = raw?.expiry_date;

            console.log("localDatalocalData", localData);
            localStorage.setItem("inventory", JSON.stringify(localData));
          }
        } catch (error) {
          console.error("Error updating inventory in localStorage:", error);
        }

        setAlertMeta(raw);

        // Parse DATES ONLY (DD-MM-YYYY format)
        const srvDate = moment(raw.server_date, [
          "DD-MM-YYYY",
          "YYYY-MM-DD",
          "YYYY/MM/DD",
        ]);
        const expDate = moment(raw.expiry_date, [
          "DD-MM-YYYY",
          "YYYY-MM-DD",
          "YYYY/MM/DD",
        ]);

        if (srvDate.isValid() && expDate.isValid()) {
          setServerDate(srvDate);
          setExpiryDate(expDate);
          const calculatedDays = expDate.diff(srvDate, "days");
          setDaysLeft(calculatedDays);
          console.log("✅ Days Left:", calculatedDays);
        }
      } catch (error) {
        console.error("❌ getExpiryNotification API error:", error);

        return null;

        // 🔥 SAMPLE DATA for testing
        const sampleData = {
          users: 5,
          branches: 3,
          godowns: 8,
          server_date: "29-12-2025",
          expiry_date: "01-01-2026", // 2 din baad - CRITICAL (0-3 days)
          message:
            "Your subscription is about to expire! Please renew to continue using all features.",
        };

        setAlertMeta(sampleData);
        const srvDate = moment(sampleData.server_date, "DD-MM-YYYY");
        const expDate = moment(sampleData.expiry_date, "DD-MM-YYYY");
        setServerDate(srvDate);
        setExpiryDate(expDate);
        const calculatedDays = expDate.diff(srvDate, "days");
        setDaysLeft(calculatedDays);
      }
    }
    if (localStorage.getItem("inventory")) {
      fetchAlertDataOnce();
    }
  }, []);
  useEffect(() => {
    // console.log("🚨 Alert Logic - Days left:", daysLeft);
    if (daysLeft < 0) {
      Swal.fire({
        title: "Subscription Expired",
        text: "Your subscription is expired. Please renew your subscription to continue using the service.",
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        if (localStorage.getItem("inventory")) {
          localStorage.removeItem("inventory");
          localStorage.removeItem("expiryAlert30DaysSeen");
        }

        window.location.href = config.baseUrl;
      });
    }
    if (daysLeft === null || daysLeft < 0) return;

    // 🔥 0-3 DAYS: Every 30min + Login/Refresh
    if (daysLeft <= 3) {
      console.log(
        "🔴 CRITICAL (0-3 days): Show immediate + start 30min interval",
      );

      // Show immediately
      showExpiryAlert();

      // Start 30min interval
      if (expiryIntervalRef.current) {
        clearInterval(expiryIntervalRef.current);
      }
      expiryIntervalRef.current = setInterval(
        () => {
          showExpiryAlert();
        },
        30 * 60 * 1000,
      ); // 30 minutes
    }
    // 🟡 4-30 DAYS: ONLY Login/Refresh (NO interval)
    else if (daysLeft <= 30) {
      console.log("🟡 WARNING (4-30 days): Show ONLY on login/refresh");

      // Show immediately - NO interval
      showExpiryAlert();

      // Clear any existing interval
      if (expiryIntervalRef.current) {
        clearInterval(expiryIntervalRef.current);
        expiryIntervalRef.current = null;
      }
    }
    // ✅ >30 days: No alert

    return () => {
      // Cleanup interval only if critical
      if (daysLeft <= 3 && expiryIntervalRef.current) {
        clearInterval(expiryIntervalRef.current);
        expiryIntervalRef.current = null;
      }
    };
  }, [daysLeft]); // Runs on l

  // const showExpiryAlert = useCallback(async () => {
  //   if (isAlertShownRef.current) return;

  //   isAlertShownRef.current = true;

  //   await Swal.fire({
  //     title: `🚨 Company Expiry Alert!`,
  //     html: `
  //     <div style="text-align: left; font-family: Arial, sans-serif;">
  //       <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  //                   color: white; padding: 15px; border-radius: 10px; margin-bottom: 15px;">
  //         <h3 style="margin: 0; font-size: 18px;">⚠️ Subscription Expiring Soon!</h3>
  //       </div>
  //       <p><strong>🏢 Company:</strong> ${comp[0]?.comp_name || "Your Company"}</p>
  //       <p><strong>📅 Expiry Date:</strong> ${
  //         expiryDate?.format("DD-MM-YY") || "N/A"
  //       }</p>
  //       <p><strong>📊 Today Date:</strong> ${
  //         serverDate?.format("DD-MM-YY") || "N/A"
  //       }</p>
  //       <p><strong>⏰ Days Left:</strong>
  //         <span style="color: ${daysLeft <= 3 ? "#ff4444" : "#ffaa00"};
  //                      font-weight: bold; font-size: 20px;">
  //           ${daysLeft} day${daysLeft !== 1 ? "s" : ""}
  //         </span>
  //       </p>
  //       ${
  //         alertMeta
  //           ? `
  //         <hr style="margin: 15px 0; border: 1px solid #eee;">
  //         <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; border-left: 4px solid #007bff;">
  //           <strong>📋 Company Stats:</strong><br/>
  //           👥 Total Users: ${alertMeta.users || 0}<br/>
  //           🏪 Total Branches: ${alertMeta.branches || 0}<br/>
  //           📦 Total Godowns: ${alertMeta.godowns || 0}<br/><br/>
  //           ${
  //             alertMeta.message
  //               ? `<strong>💡 Alert:</strong> ${alertMeta.message}`
  //               : "Please renew your subscription before expiry."
  //           }
  //         </div>
  //       `
  //           : ""
  //       }
  //     </div>
  //   `,
  //     icon: daysLeft <= 3 ? "warning" : "info",
  //     confirmButtonText: "Got it! 👍",
  //     confirmButtonColor: "#28a745",
  //     allowOutsideClick: true,
  //     allowEscapeKey: true,
  //     timer: 15000,
  //     timerProgressBar: true,
  //     width: "600px",
  //   });

  //   // Reset flag after 30 seconds
  //   setTimeout(() => {
  //     isAlertShownRef.current = false;
  //   }, 30000);
  // }, [comp?.comp_name, expiryDate, serverDate, alertMeta, daysLeft]);
  const showExpiryAlert = useCallback(async () => {
    if (isAlertShownRef.current) return;

    isAlertShownRef.current = true;

    console.log("daysLeftdaysLeft", daysLeft);
    // 🚨 CRITICAL: If expired, force logout on OK
    if (daysLeft < 0) {
      await Swal.fire({
        title: `🚨 Subscription Expired!`,
        html: `
        <div style="text-align: left; font-family: Arial, sans-serif;">
          <div style="background: linear-gradient(135deg, #ff4444 0%, #cc0000 100%); 
                      color: white; padding: 20px; border-radius: 10px; margin-bottom: 15px; text-align: center;">
            <h2 style="margin: 0; font-size: 22px;">⛔ Access Blocked!</h2>
            <p style="margin: 10px 0 0 0; font-size: 16px;">Your subscription has expired</p>
          </div>
          <p><strong>🏢 Company:</strong> ${comp[0]?.comp_name || "Your Company"}</p>
          <p><strong>📅 Expiry Date:</strong> ${expiryDate?.format("DD-MM-YY") || "N/A"}</p>
          <p><strong>📊 Today Date:</strong> ${serverDate?.format("DD-MM-YY") || "N/A"}</p>
          <p><strong>⏰ Status:</strong> 
            <span style="color: #ff4444; font-weight: bold; font-size: 24px;">
              EXPIRED
            </span>
          </p>
          <div style="background: #fff3cd; padding: 15px; border-radius: 8px; border-left: 4px solid #ffc107; margin-top: 15px;">
            <strong>⚠️ Please renew your subscription to continue using the application.</strong>
          </div>
        </div>
      `,
        icon: "error",
        confirmButtonText: "Logout & Renew",
        confirmButtonColor: "#dc3545",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false,
        width: "650px",
      });

      // Force logout after OK
      logout();
      return;
    }

    // Regular expiry warning (not expired yet)
    await Swal.fire({
      title: `🚨 Company Expiry Alert!`,
      html: `
      <div style="text-align: left; font-family: Arial, sans-serif;">
        <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); 
                    color: white; padding: 15px; border-radius: 10px; margin-bottom: 15px;">
          <h3 style="margin: 0; font-size: 18px;">⚠️ Subscription Expiring Soon!</h3>
        </div>
        <p><strong>🏢 Company:</strong> ${comp[0]?.comp_name || "Your Company"}</p>
        <p><strong>📅 Expiry Date:</strong> ${expiryDate?.format("DD-MM-YY") || "N/A"}</p>
        <p><strong>📊 Today Date:</strong> ${serverDate?.format("DD-MM-YY") || "N/A"}</p>
        <p><strong>⏰ Days Left:</strong> 
          <span style="color: ${daysLeft <= 3 ? "#ff4444" : "#ffaa00"}; 
                       font-weight: bold; font-size: 20px;">
            ${daysLeft} day${daysLeft !== 1 ? "s" : ""}
          </span>
        </p>
        ${
          alertMeta
            ? `
          <hr style="margin: 15px 0; border: 1px solid #eee;">
          <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; border-left: 4px solid #007bff;">
            <strong>📋 Company Stats:</strong><br/>
            👥 Total Users: ${alertMeta.users || 0}<br/>
            🏪 Total Branches: ${alertMeta.branches || 0}<br/>
            📦 Total Godowns: ${alertMeta.godowns || 0}<br/><br/>
            ${
              alertMeta.message
                ? `<strong>💡 Alert:</strong> ${alertMeta.message}`
                : "Please renew your subscription before expiry."
            }
          </div>
        `
            : ""
        }
      </div>
    `,
      icon: daysLeft <= 3 ? "warning" : "info",
      confirmButtonText: "Got it! 👍",
      confirmButtonColor: "#28a745",
      allowOutsideClick: true,
      allowEscapeKey: true,
      timer: 15000,
      timerProgressBar: true,
      width: "600px",
    });

    // Reset flag after 30 seconds
    setTimeout(() => {
      isAlertShownRef.current = false;
    }, 30000);
  }, [comp?.comp_name, expiryDate, serverDate, alertMeta, daysLeft]);
  const clearExpiryFlags = useCallback(() => {
    if (expiryIntervalRef.current) {
      clearInterval(expiryIntervalRef.current);
      expiryIntervalRef.current = null;
    }
    isAlertShownRef.current = false;
  }, []);

  // Add this logout function near your other functions
  const logout = useCallback(() => {
    if (localStorage.getItem("inventory")) {
      localStorage.removeItem("inventory");
      localStorage.removeItem("expiryAlert30DaysSeen");
    }
    clearExpiryFlags();
    window.location.href = config.baseUrl;
  }, [clearExpiryFlags]);

  // Update the useEffect dependency to include logout function
  useEffect(() => {
    console.log("🚨 Alert Logic - Days left:", daysLeft);
    if (daysLeft === null || daysLeft < 0) return;

    // 🔥 EXPIRED: Show alert + force logout
    if (daysLeft < 0) {
      console.log("🔴 EXPIRED: Force logout after alert");
      showExpiryAlert();
      return;
    }

    // 🔥 0-3 DAYS: Every 30min + Login/Refresh
    if (daysLeft <= 3) {
      console.log(
        "🔴 CRITICAL (0-3 days): Show immediate + start 30min interval",
      );
      showExpiryAlert();

      if (expiryIntervalRef.current) {
        clearInterval(expiryIntervalRef.current);
      }
      expiryIntervalRef.current = setInterval(
        () => {
          showExpiryAlert();
        },
        30 * 60 * 1000,
      ); // 30 minutes
    }
    // 🟡 4-30 DAYS: ONLY Login/Refresh (NO interval)
    else if (daysLeft <= 30) {
      console.log("🟡 WARNING (4-30 days): Show ONLY on login/refresh");
      showExpiryAlert();

      if (expiryIntervalRef.current) {
        clearInterval(expiryIntervalRef.current);
        expiryIntervalRef.current = null;
      }
    }

    return () => {
      if (daysLeft <= 3 && expiryIntervalRef.current) {
        clearInterval(expiryIntervalRef.current);
        expiryIntervalRef.current = null;
      }
    };
  }, [daysLeft, showExpiryAlert]); // Updated dependency

  // Existing stockInType
  const [stockInType] = useState([
    { value: 1, label: "Stock Transfer" },
    { value: 2, label: "Damaged Goods" },
    { value: 3, label: "Personal Use" },
    { value: 4, label: "Other Reason" },
    { value: 5, label: "Stock In" },
  ]);

  const [stockAdjusmentType] = useState([]);

  // Get item list
  async function getItemList() {
    try {
      const itemRes = await apiListItem({ paginate: 0, is_preload: 1 });
      setItemList(itemRes?.data?.data?.list || []);
    } catch (err) {}

    try {
      const buyerRes = await apiListBuyer({ paginate: 0 });
      setBuyerList(buyerRes?.data?.data?.list || []);
    } catch (err) {}
  }

  // Transform lists
  const itemLists =
    itemList?.map((el) => ({
      label: el?.item_name,
      value: el?.item_id,
    })) || [];

  const godownLists =
    godown?.map((el) => ({
      label: el?.godown_name,
      value: el?.godown_id,
      branch_id: el?.branch_id,
    })) || [];
  const voucherLists =
    voucherList?.map((el) => ({
      label: el?.godown_name,
      value: el?.godown_id,
      // branch_id: el?.branch_id,
    })) || [];

  const buyerLists =
    buyerList?.map((el) => ({
      label: el?.buyer_name,
      value: el?.buyer_id,
    })) || [];

  const brList =
    branchList?.map((el) => ({
      label: el?.branch_name,
      value: el?.branch_id,
    })) || [];

  // Branch list for role_id === 2
  useEffect(() => {
    if (user.role_id === 2 || user.role_id === 3) {
      apiListBranch({ paginate: 0 })
        .then((data) => {
          setBranchList(data?.data?.data?.list || []);
          // userBranchId
          setLoginBranch(
            data?.data?.data?.list.find((ele) => ele.branch_id == userBranchId),
          );
          console.log("data?.data?.data?.list ", data?.data?.data?.list);
        })
        .catch(() => {});
    }
  }, [user]);

  // Get items/buyers on login
  useEffect(() => {
    if (localStorage.getItem("inventory")) {
      getItemList();
    }
  }, []);

  // Godown list
  useEffect(() => {
    if (localStorage.getItem("inventory")) {
      const inv = JSON.parse(localStorage.getItem("inventory"));
      const userBranchId = inv?.userData?.branch_data?.[0]?.branch_id || "";
      setUserBranchId(userBranchId);

      $.post(
        `${config.apiUrl}/godown/listGodown`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          branch_id: userBranchId,
        }),
        function (res) {
          setGodown(res?.data?.list || []);
        },
      );
      $.post(
        `${config.apiUrl}/voucher/listVoucher`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          // branch_id: userBranchId,
        }),
        function (res) {
          setVoucherList(res?.data?.list || []);
        },
      );
    }
  }, []);

  // Idle timeout (4 hours = 14400 seconds)
  useEffect(() => {
    if (!localStorage.getItem("inventory")) return;

    let idleTime = 0;
    const idleInterval = setInterval(() => {
      idleTime++;
      if (idleTime >= 14400) {
        clearInterval(idleInterval);
        localStorage.removeItem("inventory");
        clearExpiryFlags();
        window.location.reload();
      }
    }, 1000);

    const resetIdleTimer = () => {
      idleTime = 0;
    };

    window.addEventListener("mousemove", resetIdleTimer);
    window.addEventListener("keydown", resetIdleTimer);
    window.addEventListener("scroll", resetIdleTimer);

    return () => {
      clearInterval(idleInterval);
      window.removeEventListener("mousemove", resetIdleTimer);
      window.removeEventListener("keydown", resetIdleTimer);
      window.removeEventListener("scroll", resetIdleTimer);
    };
  }, [clearExpiryFlags]);

  // QZ Tray Printer Setup
  useEffect(() => {
    qz.security.setCertificatePromise((resolve) => {
      resolve(
        "-----BEGIN CERTIFICATE-----\n" +
          "MIIESTCCAzGgAwIBAgIUUbWlgqkrXE95F9Y3b2NfrJ89YAowDQYJKoZIhvcNAQEL\n" +
          "BQAwgbIxCzAJBgNVBAYTAklOMRQwEgYDVQQIDAtNYWhhcmFzaHRyYTEOMAwGA1UE\n" +
          "BwwFTWFsYWQxITAfBgNVBAoMGENhYmJhZ2Vzb2Z0IFRlY2hub2xvZ2llczEhMB8G\n" +
          "A1UECwwYQ2FiYmFnZXNvZnQgVGVjaG5vbG9naWVzMRIwEAYDVQQDDAlsb2NhbGhv\n" +
          "c3QxIzAhBgkqhkiG9w0BCQEWFGZhaXpAY2FiYmFnZXNvZnQuY29tMCAXDTIzMDgy\n" +
          "MzA5MDMzMVoYDzIwNTUwMjE1MDkwMzMxWjCBsjELMAkGA1UEBhMCSU4xFDASBgNV\n" +
          "BAgMC01haGFyYXNodHJhMQ4wDAYDVQQHDAVNYWxhZDEhMB8GA1UECgwYQ2FiYmFn\n" +
          "ZXNvZnQgVGVjaG5vbG9naWVzMSEwHwYDVQQLDBhDYWJiYWdlc29mdCBUZWNobm9s\n" +
          "b2dpZXMxEjAQBgNVBAMMCWxvY2FsaG9zdDEjMCEGCSqGSIb3DQEJARYUZmFpekBj\n" +
          "YWJiYWdlc29mdC5jb20wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQC7\n" +
          "keejUP55QTNSWOhmcRS0NgpWkmuka/QgMYHOa6H7J4DYpdyONBQbz90kNdaLLaWx\n" +
          "OsaYXdYwj0ncbiQRFxQS2bQtEYaRLClJBCja9OQbMYCi4HK+nx8bunfKBhaDTYvS\n" +
          "Zs57fDg+yqGtBKDxTrqq2BOQdBILkAXTXbiHHF1UMT1F4OPNfg/d1nFiZxY0lkhs\n" +
          "8enPqW5RrmlxU6oIb8p6gBSZK1+7YnSwkGYyavsouSbj/t4cEeRYmUlsQoRcY6iJ\n" +
          "MD52+Pg6G/VaE6+5OzcQM79kUHUxkpe6xCru+taYiS40u9R3J6H9nlQ/aqfuhVaZ\n" +
          "UYobRIMqEWf4Lu+zIOkTAgMBAAGjUzBRMB0GA1UdDgQWBBSmSL7F6n1ZrUvF+zot\n" +
          "6v75uYhRMzAfBgNVHSMEGDAWgBSmSL7F6n1ZrUvF+zot6v75uYhRMzAPBgNVHRMB\n" +
          "Af8EBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQBmKPdV5BzxXN8MJCCcDMyNwhgG\n" +
          "Js7h2FsLBbHUKYxnEoWHhFoWO47vXnS73PkTSF116cY3X5b7rKQzMQfXHJ4OMQmj\n" +
          "5hS+ur6Vqjc3YlTgYmbPhbyAwCaEOJ81KLdSZqVFrwn8QYAVCIC5iYAaqYSbofZB\n" +
          "sRSjgzX7FMPaqr/8C2jQpCv2jQtYE7E4XmLexRC6vkiNZyRodzgDWhUiIbCVyW2l\n" +
          "wZ9Mv6cjmr40uTue4Nxm0Yywvz03WvXZk8RCrqaknGFtJCNZ8XDVcUDNdjeBF/cQ\n" +
          "ZFZOfcRugGoBF4TK6ufNKdwZuHNNHjrUTHh0kSGfz4ax+ot0m5i1WPkr5SNO\n" +
          "-----END CERTIFICATE-----",
      );
    });

    qz.security.setSignaturePromise((toSign) => {
      return (resolve, reject) => {
        const privateKey =
          "-----BEGIN PRIVATE KEY-----\n" +
          "MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC7keejUP55QTNS\n" +
          "WOhmcRS0NgpWkmuka/QgMYHOa6H7J4DYpdyONBQbz90kNdaLLaWxOsaYXdYwj0nc\n" +
          "biQRFxQS2bQtEYaRLClJBCja9OQbMYCi4HK+nx8bunfKBhaDTYvSZs57fDg+yqGt\n" +
          "BKDxTrqq2BOQdBILkAXTXbiHHF1UMT1F4OPNfg/d1nFiZxY0lkhs8enPqW5Rrmlx\n" +
          "U6oIb8p6gBSZK1+7YnSwkGYyavsouSbj/t4cEeRYmUlsQoRcY6iJMD52+Pg6G/Va\n" +
          "E6+5OzcQM79kUHUxkpe6xCru+taYiS40u9R3J6H9nlQ/aqfuhVaZUYobRIMqEWf4\n" +
          "Lu+zIOkTAgMBAAECggEAOLy5xL0LPMJsM8yQ/+vUx25RUj6YMPQ2tEZFbZtBNCeO\n" +
          "4fnJ7XnzWzZVPk7Kxu7X3/RXfl9kGuw8+2CVqFXCzLDtv3Q9sEwbcOrBMPpCxbcD\n" +
          "okEidGbNkiWldobA6JbcZJiUfOXmXZgNr7hmtpeJ/4O850U08CpwmK8Q0k3SLVTy\n" +
          "akrJyfTFn9F5pVKCDyPFuuTt5Zhw2IxXad8990u2EoE7erFSyDIjxApDL7aGuEFK\n" +
          "XmDDNgzr0kqGhe6ZjUn0I3NHcqA0l3jaxHMVlIC2Qoe316Q7J2NFNL2V5vMyPoDQ\n" +
          "rqJoylFSjtTxMPSu0IBbwtJOQA521RIrPiDD+mPSAQKBgQDyCMKVjJ8Ht63jd2+x\n" +
          "M+G8w97OVgK1WEDztsR3GraXB2q2NP4IOQnc0H8CxpeyEUfSwJfS/t2kPA8GR94v\n" +
          "6os6/D7urYtCUCGFqLirrL2sR4RE9DVUxfex9MykYlk1QNxDOzVxYUWf41NTqnzM\n" +
          "2m25jjiL/maK9t0jcvTP8O9LQwKBgQDGZJ5bNYaayeo9dJ+xbiM649K8S35ZTBx3\n" +
          "TSwgqWoZpTKHJdHXsjfLCWrCwAAJ4dM7WS+mMkcHTThT31C1MfSCc9iVV0bF7lmo\n" +
          "jDEmP9tqGKw+u8do//oxSslP8YzZhUxwC0ES9bn28X4JY+J+pzcRVA8PpRInrTMG\n" +
          "Hi0UdQZF8QKBgQDqUM7I532ihBGFcMCiBj9ZdysCCUTP+aPQDjX/tM3mQxjtUzpI\n" +
          "DahdrT/5GPgNPSuSfj+91l4PPNGy2+rf6qpmLYRjn4F9boQ1mNVH5pEt84K7Gs1y\n" +
          "x8F3+C4SSuBgbO2Q7QZdQLWeB/9ItXni/OhTRru51E3D5SDLy+P0WCXibwKBgE+T\n" +
          "Zk0xYAdQPAtgbvltMuZZIVrzcP+CXtyfcLa9HViiAW1iBxRcYLKo2VC6UImmMeLZ\n" +
          "OBqSihjsqU5DAY1cNzXoH5RvSGz12LKZYNF1xZ19vgD/stFz8ze4Rp0xRwyswecj\n" +
          "LHvdYjUh0isUDHI+wgDKVawxyuFtQE0Q54YQFm8RAoGBAIX6YZpenHRkip6jfk48\n" +
          "ZjWBJaw5hnNQwjALKpZLMY9hmTwrxw/TzdiT9jODr7rPMw9Daw5ChsxR7v7TN/Qr\n" +
          "tQDezA4g37XET5n4hCx1YMtobmWZuXVURRbfb2QMnkm3k+46M69AnC76CRN9y0gs\n" +
          "q/8daUmzsPnitjpvN9t3Tdxs\n" +
          "-----END PRIVATE KEY-----";

        try {
          let pk = KEYUTIL.getKey(privateKey);
          let sig = new KJUR.crypto.Signature({ alg: "SHA1withRSA" });
          sig.init(pk);
          sig.updateString(toSign);
          let hex = sig.sign();
          resolve(stob64(hextorstr(hex)));
        } catch (err) {
          reject(err);
        }
      };
    });

    qz.websocket
      .connect()
      .then(() => qz.printers.getDefault())
      .then((printerName) => {
        localStorage.setItem("defaultPrinter", printerName);
        return qz.websocket.disconnect();
      })
      .catch(() => {
        localStorage.setItem("defaultPrinter", "");
        return qz.websocket.disconnect();
      });
  }, []);

  // Company config
  const [accessCode, setAccessCode] = useState("");
  const [erpIntegration, setErpIntegration] = useState("");
  const [noPricePrint, setNoPricePrint] = useState("");
  const [itemLevelNarration, setItemLevelNarration] = useState("");
  const [multiVoucher, setMultiVoucher] = useState("");
  const [multiPurchaseVoucher, setMultiPurchaseVoucher] = useState("");
  const [isPurchaseVoucherNo, setIsPurchaseVoucherNo] = useState("");
  const [displayQty, setDisplayQty] = useState("");

  const [exportNewChallan, setExportNewChallan] = useState("");

  useEffect(() => {
    async function getCompany() {
      try {
        const inv = JSON.parse(localStorage.getItem("inventory"));
        const response = await $.post(
          `${config.apiUrl}/company/listCompany`,
          JSON.stringify({
            comp_id: inv?.userData?.comp_id,
          }),
        );
        const companyData = response?.data?.list[0];
        if (companyData) {
          console.log("companyDatacompanyData", companyData);
          setAccessCode(companyData.access_code_permission || "");
          setNoPricePrint(companyData.allow_no_price_print || "");
          setErpIntegration(companyData.is_erp_integrated || "");
          setItemLevelNarration(companyData.item_level_narration || "");
          setMultiVoucher(companyData.is_multi_voucher || "");
          setMultiPurchaseVoucher(companyData.is_multi_purchase || "");
          setDisplayQty(companyData.display_qty || "");
          setIsPurchaseVoucherNo(companyData.is_purchase_voucher_no || "0");
          setExportNewChallan(companyData.export_new_challan || "");
        }
      } catch (error) {
        console.error("Error fetching company:", error);
      }
    }

    if (localStorage.getItem("inventory")) {
      getCompany();
    }
  }, []);

  return (
    <ConfigContext.Provider
      value={{
        accessCode,
        noPricePrint,
        erpIntegration,
        itemLevelNarration,
        multiVoucher,
        multiPurchaseVoucher,
        displayQty,
        isPurchaseVoucherNo,
        exportNewChallan,
        loginBranch,
        branchList,
      }}
    >
      <div>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route
            exact
            path="/login"
            element={
              localStorage.getItem("inventory") ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <LoginPinBased />
              )
            }
          />

          <Route element={<ProtectedRoute />}>
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/logout" element={<Logout />} />

            <Route exact path="/branch" element={<BranList />} />
            <Route exact path="/company" element={<CompanyList />} />
            <Route exact path="/godown" element={<GodownList />} />
            <Route exact path="/buyer" element={<BuyerList />} />
            <Route exact path="/item-category" element={<ItemCatList />} />
            <Route exact path="/user" element={<UserList />} />
            <Route exact path="/item" element={<ItemList />} />
            <Route exact path="/customer" element={<CustomerList />} />
            <Route exact path="/uom" element={<UOMList />} />
            <Route exact path="/sync-log" element={<SyncLogList />} />

            <Route
              exact
              path="/category/expense"
              element={<ExpenseCategoryList />}
            />
            <Route
              exact
              path="/category/expense/add"
              element={<ExpenseCategoryAdd />}
            />
            <Route
              exact
              path="/category/expense/edit/:id"
              element={<ExpenseCategoryEdit />}
            />

            <Route
              exact
              path="/purchase"
              element={<PurchaseList branchList={brList} />}
            />
            <Route
              exact
              path="/purchase/add"
              element={<PurchaseAdd godown={godown} />}
            />
            <Route
              exact
              path="/purchase/view/:id"
              element={<PurchaseView godown={godown} branchList={brList} />}
            />
            <Route
              exact
              path="/purchase/edit/:id"
              element={<PurchaseEdit godown={godown} />}
            />

            <Route
              exact
              path="/challan"
              element={<SaleList branchList={brList} />}
            />
            <Route
              exact
              path="/challan/add"
              element={<SaleAdd godown={godown} voucherList={voucherList} />}
            />
            <Route
              exact
              path="/challan/view/:id"
              element={<SaleView godown={godown} voucherList={voucherList} />}
            />
            <Route
              exact
              path="/challan/edit/:id"
              element={<SaleEdit godown={godown} voucherList={voucherList} />}
            />

            <Route
              exact
              path="/temp-challan"
              element={<TempSaleList branchList={brList} />}
            />

            <Route
              exact
              path="/challanRtn"
              element={<ChallanRtnList branchList={brList} />}
            />
            <Route
              exact
              path="/challanRtn/add"
              element={<ChallanReturnAdd godown={godown} />}
            />
            <Route
              exact
              path="/challanRtn/view/:id"
              element={<ChallanReturnView godown={godown} />}
            />
            <Route
              exact
              path="/challanRtn/edit/:id"
              element={<ChallanReturnEdit godown={godown} />}
            />

            <Route
              exact
              path="/stock-adjustment"
              element={
                <StockAdjustment
                  stockInType={stockInType}
                  stockAdjusmentType={stockAdjusmentType}
                  item={itemLists}
                  branchList={brList}
                />
              }
            />
            <Route
              exact
              path="/stock-adjustment/add"
              element={
                <StockAdjustmentAdd
                  stockInType={stockInType}
                  stockAdjusmentType={stockAdjusmentType}
                  compConfig={compConfig}
                  setCompConfig={setCompConfig}
                  godown={godownLists}
                  godownListAll={godown}
                  item={itemLists}
                  userBrnch={userBranchId}
                />
              }
            />
            <Route
              exact
              path="/stock-adjustment/edit/:id"
              element={
                <StockAdjustmentEdit
                  stockInType={stockInType}
                  stockAdjusmentType={stockAdjusmentType}
                  compConfig={compConfig}
                  setCompConfig={setCompConfig}
                  godown={godownLists}
                  godownListAll={godown}
                  item={itemLists}
                  userBrnch={userBranchId}
                />
              }
            />
            <Route
              exact
              path="/stock-adjustment/view/:id"
              element={
                <StockAdjustmentView
                  stockInType={stockInType}
                  stockAdjusmentType={stockAdjusmentType}
                  godown={godown}
                  branchList={brList}
                  userBrnch={userBranchId}
                />
              }
            />

            <Route
              exact
              path="/expense"
              element={<ExpenseList branchList={brList} />}
            />
            <Route exact path="/expense/add" element={<ExpenseAdd />} />
            <Route exact path="/expense/view/:id" element={<ExpenseView />} />
            <Route exact path="/expense/edit/:id" element={<ExpenseEdit />} />

            <Route exact path="/stock/list" element={<StockSummary />} />
            <Route
              exact
              path="/stock/movement"
              element={<StockMovement branchList={brList} />}
            />
            <Route
              exact
              path="/sale/item-movement"
              element={<SaleItemMovement branchList={brList} />}
            />
            <Route
              exact
              path="/itemized-purchase"
              element={<ItemizedPurchase branchList={brList} />}
            />
            <Route
              exact
              path="/Item/Non-Moving-Item"
              element={<NonMovingItems branchList={brList} />}
            />
            <Route
              exact
              path="/sale/movement"
              element={<SaleMovement branchList={brList} />}
            />
            <Route
              exact
              path="/purchase-movement"
              element={<PurchaseMovement branchList={brList} />}
            />
            <Route
              exact
              path="/sale-return/movement"
              element={<SaleReturnMovement branchList={brList} />}
            />
            <Route
              exact
              path="/purchase-return-movement"
              element={<PurchaseReturnMovement branchList={brList} />}
            />
            <Route
              exact
              path="/payment/list"
              element={
                isRestrictedUser() ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <PaymentSummary branchList={brList} />
                )
              }
            />
            <Route
              exact
              path="/payment/movement"
              element={
                isRestrictedUser() ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <PaymentMovement branchList={brList} />
                )
              }
            />

            <Route
              exact
              path="/purchase-return"
              element={
                <PurchaseReturnList
                  itemLists={itemLists}
                  branchList={brList}
                  buyerLists={buyerLists}
                />
              }
            />
            <Route
              exact
              path="/purchase-return/add"
              element={
                <PurchaseReturnAdd
                  compConfig={compConfig}
                  setCompConfig={setCompConfig}
                  itemLists={itemLists}
                  godown={godownLists}
                  branchList={brList}
                />
              }
            />
            <Route
              exact
              path="/purchase-return/view/:id"
              element={
                <PurchaseReturnView
                  itemLists={itemLists}
                  godown={godownLists}
                  branchList={brList}
                />
              }
            />
            <Route
              exact
              path="/purchase-return/edit/:id"
              element={
                <PurchaseReturnEdit
                  compConfig={compConfig}
                  setCompConfig={setCompConfig}
                  itemLists={itemLists}
                  godown={godownLists}
                  branchList={brList}
                />
              }
            />

            <Route
              exact
              path="/setting"
              element={<SettingList setCompConfig={setCompConfig} />}
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </ConfigContext.Provider>
  );
}

export default App;
